import { CreateResponsiveStyle, DEVICE_SIZES, maxSize } from "rn-responsive-styles";
import colors from "@assets/colors";

const useStyles = CreateResponsiveStyle(
  {
    drawer_tab_container: {
      height: 60,
      minWidth: 250,
      paddingLeft: 23,
      paddingRight: 100,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: 'flex-end',
      zIndex: 99,
    },
    activeBG: {
      backgroundColor: colors.white,
      borderTopLeftRadius: 20,
      borderBottomLeftRadius: 20,
    },
    activeHover: {
      backgroundColor: "rgba(255,255,255,0.1)",
      borderTopLeftRadius: 20,
      borderBottomLeftRadius: 20,
    },
    activeHoverText: {
      color: colors.white,
      fontFamily: "DMSans-Bold",
    },
    drawer_tab_label: {
      fontSize: 20,
      lineHeight: 14,
      marginLeft: 20,
      fontFamily: "DMSans-Bold",
      color: colors.white,
    },
    drawer_tab_label_comingSoon: {
      color: "#FFFFFF",
      fontFamily: "DMSans",
      fontWeight: "100",
      fontSize: 12,
      left: "5%",
    },
    v_margintop: { 
      marginTop: 37,
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      drawer_tab_container: { paddingLeft: 17.25, height: 45 },
      drawer_tab_label: { fontSize: 15, lineHeight: 10.5, marginLeft: 26.25 },
      activeBG: { borderTopLeftRadius: 15, borderBottomLeftRadius: 15 },
      activeHover: { borderTopLeftRadius: 15, borderBottomLeftRadius: 15 }
    },
    [DEVICE_SIZES.MD]: {
      drawer_tab_label: { fontSize: 16, fontWeight: "500", lineHeight: 12, color: colors.black3 },
      drawer_tab_container: { paddingLeft: 17.25, height: 45, top: 60 },
      drawer_tab_label_comingSoon: {
        color: colors.black3,
        fontFamily: "DMSans",
        fontWeight: "100",
        fontSize: 12,
        left: "21%",
        top: 40,
      },
    },
    [maxSize(DEVICE_SIZES.SM)]: {
      v_margintop: { marginTop: 0 },
      drawer_tab_label: { fontSize: 16, fontWeight: "500", lineHeight: 12, color: colors.black3 },
      drawer_tab_container: { paddingHorizontal: 24, top: 35, height: 40 },
      drawer_tab_label_comingSoon: {
        color: colors.black3,
        fontFamily: "DMSans",
        fontWeight: "100",
        fontSize: 12,
        left: "21%",
        top: 15,
      },
    },
    [maxSize(DEVICE_SIZES.XS)]: {
      v_margintop: { marginTop: 0 },
      drawer_tab_label: { fontSize: 16, fontWeight: "500", lineHeight: 12, color: colors.black3 },
      drawer_tab_container: { paddingHorizontal: 24, top: 35, height: 40 },
      drawer_tab_label_comingSoon: {
        color: colors.black3,
        fontFamily: "DMSans",
        fontWeight: "100",
        fontSize: 12,
        left: "21%",
        top: 15,
      },
    },
  }
);

export default useStyles;
